module.exports = __webpack_public_path__ + "img/provider_arrow.dda0f212.svg";